export { default, links, meta } from "/app/app/routes/privacy.mdx";